import apiClient from "services/axios";

const API = {
  list: "/api/v1/monitorings",
  create: "/api/v1/monitorings",
  detail: "/api/v1/monitorings",
  update: "/api/v1/monitorings",
  delete: "/api/v1/monitorings",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  let payload = body;
  if (body.bgImageFile) {
    payload = new FormData();
    payload.append("name", body.name);
    payload.append("type", body.type);
    payload.append("bgImageFile", body.bgImageFile);
    payload.append("description", body.description);
  }

  const response = await apiClient.post(API.create, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id, filter) => {
  const response = await apiClient.get(`${API.detail}/${id}`, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  let payload = body;
  if (body.bgImageFile) {
    payload = new FormData();
    payload.append("name", body.name);
    payload.append("bgImageFile", body.bgImageFile);
    payload.append("description", body.description);
  }
  const response = await apiClient.patch(`${API.update}/${id}`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
